import React, {Component, Fragment} from 'react';
import {connect} from "react-redux";
import iconInstallation from './../../img/general/icon-included.png';
import {removeFromCart, clearCart, clearDeliveryData} from "../../actionCreators";
import {Link, withRouter} from "react-router-dom";
import Alert from "../Alerts/Alert";

class ShopCart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isShowAlertDeleteCart: false,
      showAlertTextRemove: 'Möchten Sie diesen Artikel wirklich löschen?',
      showAlertBtnRemove: 'ja',
      idDeleteProduct: '',
      isShowAlertGoHome: false,
      showAlertTextGoHome: 'Sicher, dass Sie zur Startseite gehen möchten. Warenkorb- und Lieferdaten werden gelöscht',
      showAlertBtnGoHome: 'Continue'
    };
  }

  deleteFromCart = (e) => {
    const {removeFromCart} = this.props;
    const {idDeleteProduct} = this.state;
    removeFromCart(idDeleteProduct);
    this.closeAlert();
  };

  showAlertGoHome = (e) => {
    const {cart} = this.props;
    const {goToHomePage} = this;

    if(cart.length !== 0) {
      this.setState({
        isShowAlertGoHome: true,
      })
    } else {
      goToHomePage();
    }
  };

  showAlertDeleteProduct = (e) => {
    let idProduct = e.currentTarget.dataset.id;
    this.setState({
      isShowAlertDeleteCart: true,
      idDeleteProduct: idProduct ? idProduct : null
    })
  }

  closeAlert = (e) => {
    this.setState({
      isShowAlertDeleteCart: false,
      isShowAlertGoHome: false
    })
  };

  goToHomePage = (e) => {
    const {history, clearCart, clearDeliveryData} = this.props;
    clearCart();
    clearDeliveryData();
    history.push('/');
  };

  showAlerts = () => {
    const {isShowAlertDeleteCart, showAlertTextRemove, isShowAlertGoHome, showAlertTextGoHome, showAlertBtnRemove, showAlertBtnGoHome} = this.state;
    const {closeAlert, deleteFromCart, goToHomePage} = this;

    if(isShowAlertDeleteCart) {
      return <Alert closeAlert={closeAlert} someActionDo={deleteFromCart} alertText={showAlertTextRemove} btnSomeActionDoText={showAlertBtnRemove} />
    }

    if(isShowAlertGoHome) {
      return <Alert closeAlert={closeAlert} someActionDo={goToHomePage} alertText={showAlertTextGoHome} btnSomeActionDoText={showAlertBtnGoHome}/>
    }
  }

  renderCartList = () => {
    const {cart} = this.props;
    const {showAlertDeleteProduct} = this;
    const cartElements = cart.map(cartItem => (
      <li key={cartItem.randomId} className="shop-chosen__item">
        <div className="shop-chosen__top">
          <div className="shop-chosen__title">{cartItem.name}</div>
          <button className="shop-chosen__delete" type="button" data-id={cartItem.randomId} data-alert="isShowAlertDeleteCart" onClick={showAlertDeleteProduct}>löschen</button>
        </div>
        <div className="shop-chosen__bottom">
          <div className="shop-chosen__left">
            <div className="shop-chosen__img">
              <img src={cartItem.icon} alt="" />
            </div>
          </div>
          <div className="shop-chosen__right">
            <ul className="shop-chosen__feature">
              <li className="shop-chosen__feature-item">
                <div className="shop-chosen__feature-left">Anzahl</div>
                <div className="shop-chosen__feature-right">{cartItem.quantity} Stk.</div>
              </li>
              {cartItem.cost ? (
              <li className="shop-chosen__feature-item">
                <div className="shop-chosen__feature-left">Preis/Artikel</div>
                <div className="shop-chosen__feature-right">{cartItem.cost} &euro;</div>
              </li>
              ) : ( '' )}
              {cartItem.size ? (
                <li className="shop-chosen__feature-item">
                  <div className="shop-chosen__feature-left">Gesamtlänge</div>
                  <div className="shop-chosen__feature-right">{cartItem.size} m</div>
                </li>
              ) : ( '' )}
              {cartItem.installation ? (
              <li className="shop-chosen__feature-item">
                <div className="shop-chosen__feature-left">Montage</div>
                <div className="shop-chosen__feature-right">
                  <img src={iconInstallation} alt="" />
                </div>
              </li>
              ) : ( '' )}
              {cartItem.bringInWindow ? (
              <li className="shop-chosen__feature-item">
                <div className="shop-chosen__feature-left">Möbellift</div>
                <div className="shop-chosen__feature-right">
                  <img src={iconInstallation} alt="" />
                </div>
              </li>
              ) : ( '' )}
            </ul>
          </div>
        </div>
      </li>
    ));
    return (
      <ul className="shop-chosen__list">
        {cartElements}
      </ul>
    )
  };

  render() {
    const {renderCartList, showAlertGoHome, showAlerts} = this;
    const {cart} = this.props;
    return (
      <Fragment>
        <section className="shop-chosen">
          <div className="container">
            {cart.length !== 0 ? (
            <div className="shop-chosen__wrap">
              <h2>Sie haben bereits gewählt:</h2>
              { renderCartList() }
            </div>
            ) : (
              ''
            )}
            <button data-alert="isShowAlertGoHome" onClick={showAlertGoHome} className="shop-btn shop-btn--prev" type="button" title="zurück" aria-label="zurück"></button>
            { cart.length !== 0 ? (<Link to="/delivery-address" className="shop-btn shop-btn--next" type="button" title="Weiter zum Lieferpreis" aria-label="Weiter zum Lieferpreis"></Link>) : ''}
          </div>
        </section>

        { showAlerts() }

      </Fragment>
    );
  }
}

export default withRouter(connect((state) => {
  return {
    cart: state.cart,
  }
}, {removeFromCart, clearCart, clearDeliveryData})(ShopCart));


// WEBPACK FOOTER //
// ./src/components/Shop/ShopCart.js